import { combineReducers } from 'redux';

const skinCareInitialState = {
  list: null,
  loadStatus: 0,
  loadCategoryStatus: 0,
  categoryList: [],
  page: 0,
  pageSize: 10,
  noMoreData: false
};

const skinCareDetailInitialState = {
  data: null,
  loadStatus: 0,
  shareImg: '',
  isFromSkin: false,
};

const skinCommentInitialState = {
  list: null,
  count: 0,
  loadStatus: 0,
}

const commentListInitialState = {
  list: null,
  count: 0,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    size: 20,
  }
}

const feedbackInitialState = {
  saveStatus: 0,
}

const writeCommentInitialState = {
  saveStatus: 0,
}

function skinCareReducer(state = skinCareInitialState, action) {
  switch (action.type) {
    case 'UPDATE_SKIN_CARE_DATA': {
      return {
        ...state,
        ...action.data
      }
    }
    case 'LOAD_SKIN_CARE_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_SKIN_CARE_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      let newList = null
      if(state.list) {
        newList = [...state.list, ...action.data.listData]
      }else {
        newList = action.data.listData
      }
      console.log(newList,'new list--------')
      return {
        ...state,
        loadStatus: 2,
        list: newList
      };
    }

    case 'LOAD_SKIN_CARE_CATEGORY_LIST': {
      return {
        ...state,
        loadCategoryStatus: 1,
      };
    }

    case 'LOAD_SKIN_CARE_CATEGORY_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadCategoryStatus: 0,
        };
      }
      return {
        ...state,
        loadCategoryStatus: 2,
        categoryList: action.data,
      };
    }

    default:
      return state;
  }
}

function skinCareDetailReducer(state = skinCareDetailInitialState, action) {
  switch (action.type) {
    case 'SAVE_SKIN_CART_STATUS': {
      return {
        ...state,
        isFromSkin: action.isFromSkin,
      }
    }
    case 'LOAD_SKIN_CARE_DETAIL': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_SKIN_CARE_DETAIL_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      return {
        ...state,
        loadStatus: 2,
        data: action.data,
      };
    }

    case 'LOAD_SKIN_CARE_SHARE_IMG_COMPLETION': {
      return {
        ...state,
        shareImg: action.data,
      }
    }

    default:
      return state;
  }
}

function skinCommentReducer(state = skinCommentInitialState, action) {
  switch (action.type) {
    case 'LOAD_SKIN_COMMENT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_SKIN_COMMENT_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      return {
        ...state,
        count: action.data.count,
        list: action.data.listData,
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function commentListReducer(state = commentListInitialState, action) {
  switch (action.type) {
    case 'LOAD_SKIN_COMMENT_ALL_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        }
      }
      return {
        ...state,
        loadStatus: 1,
        list: null
      }
    }

    case 'LOAD_SKIN_COMMENT_ALL_LIST_COMPLETION': {
      const { count, listData } = action.data;
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      return {
        ...state,
        count: count,
        list: state.list ? state.list.concat(listData) : listData,
        didLoadAll: listData.length < state.query.size,
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function feedbackReducer(state = feedbackInitialState, action) {
  switch (action.type) {
    case 'ADD_FEED_BACK': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'ADD_FEED_BACK_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
      };
    }

    default:
      return state;
  }
}

function writeCommentReducer(state = writeCommentInitialState, action) {
  switch (action.type) {
    case 'ADD_SKIN_CARE_COMMENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'ADD_SKIN_CARE_COMMENT_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  skinCare: combineReducers({
    list: skinCareReducer,
    detail: skinCareDetailReducer,
    feedback: feedbackReducer,
  }),
  comment: combineReducers({
    list: skinCommentReducer,
    allList: commentListReducer,
    write: writeCommentReducer,
  }),
});
